import React from "react";
import { withRouter } from "react-router-dom";
import { Button, Card, Col, message, Row, Table, Upload } from "antd";

import { API_ENDPOINT } from "../../../index";


import { IotDeviceService } from "../../../services";

class LockerBoxConfigurator extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            fetchLockerAttempted: false,
            lockerBoxes: []
        };
    }

    async componentDidMount() {

        const { lockerDeviceName } = this.props.match.params;

        try{
            
            let res = await IotDeviceService.LockerService.getBoxes( lockerDeviceName );

            this.setState({
                fetchLockerAttempted: true,
                lockerBoxes: res.data.lockerBoxes
            });

        } catch( e ){
            console.log( e );
        }

    }

    render() {

        return (
            <Card loading={!this.state.fetchLockerAttempted} title={(this.renderTitle())}>
                {this.renderTable()}
            </Card>
        );

    }

    renderTitle() {

        const { lockerDeviceName } = this.props.match.params;

        return (
            <Row type="flex" justify="space-between">
                <Col>
                    <span>{lockerDeviceName}: Box Configurator</span>
                </Col>
                <Col>
                    <Row type="flex" gutter={8}>
                        <Col>
                            <Button href={`${API_ENDPOINT}/api/admin/iot-locker/${lockerDeviceName}/download-box-config`} download={true} type="primary">
                                Download Excel Sheet
                            </Button>
                        </Col>
                        <Col>
                            <Upload
                                showUploadList={false}
                                name="boxConfig"
                                action={`${API_ENDPOINT}/api/admin/iot-locker/${lockerDeviceName}/upload-box-config`}
                                withCredentials={true}
                                onChange={this.onChangeUploadStatus}>
                                <Button type="primary">
                                    Upload Excel Sheet
                                </Button>
                            </Upload>
                        </Col>
                    </Row>
                </Col>
            </Row>
        )
    }

    renderTable() {

        let tableColumns = [
            {
                title: "#",
                key: "indexNumber",
                render: (text, record, index) => {
                    return index + 1;
                }
            },
            {
                title: "Box Name",
                dataIndex: "boxName"
            },
            {
                title: "Box Size",
                dataIndex: "boxSize"
            },
            {
                title: "Booking Id",
                key: "iotLockerBoxBookingId",
                render: (text, record, index) => {

                    if (record.availableForBooking) {
                        return "-";
                    }

                    return (
                        <a href={`/iot-devices/locker/box-booking/${record.lockerSlotBookingId}`}>
                            View Booking
                        </a>
                    )
                }
            }
        ];

        return (
            <Table
                pagination={ false }
                size="small"
                columns={tableColumns}
                dataSource={this.state.lockerBoxes}
            />
        )

    }

    onChangeUploadStatus = (info) => {

        console.log( info.file.status );

        if (info.file.status !== 'uploading') {
            console.log(info.file, info.fileList);
        }

        if (info.file.status === 'done') {
            
            message.success(`${info.file.name} file uploaded successfully`);
            this.setState({
                lockerBoxes: info.file.response.lockerBoxes
            })

        } else if (info.file.status === 'error') {

            message.error(`${info.file.name} file upload failed.`);

        }
    }

}

export default withRouter(LockerBoxConfigurator);


// WEBPACK FOOTER //
// ./src/components/iot-devices/locker/box-configurator.js